export default __webpack_public_path__ + "static/media/background2.74b83e9b.png";